/**
 * 指挥页队员轨迹线颜色（历史 / 实时共用）
 * trackColors[name] 手动覆盖优先；否则对 device_unique_id||name 稳定哈希取高对比色板。
 */

/** 高对比色板（约 12 色，适合同区多人轨迹区分；卫星/二维均较易辨认） */
export const MEMBER_TRACK_COLORS = [
  '#e41a1c', // 红
  '#377eb8', // 蓝
  '#4daf4a', // 绿
  '#984ea3', // 紫
  '#ff7f00', // 橙
  '#a65628', // 棕
  '#f781bf', // 粉
  '#00acc1', // 青
  '#5e35b1', // 靛
  '#c2185b', // 玫红
  '#558b2f', // 草绿
  '#f9a825'  // 琥珀黄
];

/** djb2 稳定哈希（同 key 跨会话同色） */
export function hashTrackKey(key) {
  const s = String(key == null ? '' : key);
  let h = 5381;
  for (let i = 0; i < s.length; i += 1) {
    h = ((h << 5) + h) + s.charCodeAt(i);
    h |= 0;
  }
  return Math.abs(h);
}

/**
 * 从队员列表解析用于哈希的稳定键：device_unique_id 优先，否则 name。
 */
export function resolveMemberTrackHashKey(memberName, members = []) {
  const name = String(memberName || 'unknown');
  const list = Array.isArray(members) ? members : [];
  const m = list.find((x) => x && String(x.name) === name);
  const id = m && (m.device_unique_id || m.deviceUniqueId);
  if (id != null && String(id).trim() !== '') return String(id);
  return name;
}

/**
 * @param {string} memberKey 覆盖查找键 / 缺省哈希键（通常为队员 name）
 * @param {Record<string,string>} [trackColors] 手动配色 name→#hex
 * @param {{ name?: string, deviceUniqueId?: string, device_unique_id?: string, members?: Array, palette?: string[] }} [options]
 * @returns {string} #rrggbb
 */
export function resolveTrackColor(memberKey, trackColors = {}, options = {}) {
  const name = String(
    options.name != null ? options.name : (memberKey != null ? memberKey : 'unknown')
  );
  const overrides = trackColors && typeof trackColors === 'object' ? trackColors : {};
  if (overrides[name]) return overrides[name];

  let hashKey;
  const deviceId = options.deviceUniqueId || options.device_unique_id;
  if (deviceId != null && String(deviceId).trim() !== '') {
    hashKey = String(deviceId);
  } else if (Array.isArray(options.members) && options.members.length) {
    hashKey = resolveMemberTrackHashKey(name, options.members);
  } else {
    hashKey = String(memberKey != null ? memberKey : name);
  }

  if (overrides[hashKey]) return overrides[hashKey];

  const palette =
    Array.isArray(options.palette) && options.palette.length
      ? options.palette
      : MEMBER_TRACK_COLORS;
  const idx = hashTrackKey(hashKey) % palette.length;
  return palette[idx];
}
